import React from 'react';

import { ChipProps } from './types';

import { classNames } from '@/shared/lib/classNames/classNames';

export const Chip = ({ label, className }: ChipProps) => {
  return (
    <div
      className={classNames({
        cls: 'bg-custom-surface-contrast-low h-fit rounded-xl px-4 py-3 text-sm leading-4 font-medium backdrop-blur-2xl max-sm:text-[12px]',
        additional: [className],
      })}
    >
      {label}
    </div>
  );
};
